<template>
	<div @click="showModal">
		<template>
			<app-image :src="storie.image" :class="$style.postImage" />
		</template>
		<a-modal
			:title="storie.createdAt | moment('DD/MM/YYYY')"
			v-model="show"
			@cancel="handleHide"
			:width="500"
			:bodyStyle="{ padding: '0px' }"
			:footer="null"
			:destroyOnClose="true"
		>
			<div class="width-500">
				<template>
					<app-image :src="storie.image" style="max-width:100%;" />
				</template>
			</div>
			<div class="py-2 bg-gray-1 pl-3">
				<div class="d-flex flex-wrap">
					<div class="d-flex flex-wrap font-size-16">
						<div class="mr-3 my-2 text-nowrap">
							<i class="fa fa-at font-size-20 mr-1"></i>
							{{ storie.mention }}
						</div>
						<div class="mr-3 my-2 text-nowrap">
							<i class="fa fa-hashtag font-size-20 mr-1"></i>
							{{ storie.hashtag }}
						</div>
					</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
// import AppVideo from '../Video'
import AppImage from '../Image'

export default {
	name: 'DetailImageModal',
	components: {
		// AppVideo,
		AppImage,
	},
	props: {
		storie: {
			type: Object,
			required: true,
		},
	},
	data: function() {
		return {
			show: false,
		}
	},
	methods: {
		onError(e) {},
		handleHide() {
			this.show = false
		},
		showModal() {
			this.show = true
		},
	},
}
</script>

<style lang="scss" module>
@import './imagemodal.style.module.scss';
</style>
